"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgUnArchiveOutlined = (props) => (React.createElement("span", { className: "anticon" },
    React.createElement("svg", Object.assign({ fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", className: "PayPing-icon" }, props),
        React.createElement("path", { d: "m22.03 6.5553v15.812h-20.06v-15.812", strokeLinecap: "square" }),
        React.createElement("path", { d: "m23.367 1.6327h-22.735v4.0276h22.735z" }),
        React.createElement("path", { d: "m15.342 13.044-3.3433-3.3563-3.3433 3.3563" }),
        React.createElement("path", { d: "m12 10.847v6.3922" }))));
exports.default = SvgUnArchiveOutlined;
//# sourceMappingURL=UnArchiveOutlined.js.map